export default {
  page: {
    name: 'String',
    title: 'String',
    description: 'String',
    store_id: 'String',
    list_id: 'String',
    type: 'String',
  },
}
